<!-- Upload files through links -->
<p-dialog class="title_five fw-semibold" [(visible)]="isVisible" [modal]="true" [closable]="false" [draggable]="false"
    [resizable]="false" styleClass="link-upload-dialog" (onHide)="closeLinkDialog()">

    <!-- Custom Header Template -->
    <ng-template pTemplate="header">
        <div class="modal-header">
            <h5 class="modal-title" id="linkModalLabel">
                <img src="assets/img/link.png" alt="Link" width="48" height="40">
                Upload File from Link
            </h5>
        </div>
    </ng-template>

    

    <div class="link-upload-content">
        <div class="field">
            <label for="fileUrl">File URL<span class="text-danger">*</span></label>
            <span class="p-input-icon-right w-full">
                <input id="fileUrl" type="text" [(ngModel)]="fileUrl" placeholder="Paste your file URL here"
                    class="w-full p-inputtext" [ngClass]="{'p-invalid': !!linkError, 'p-disabled': isProcessingLink}"
                    (paste)="onUrlPaste($event)" (input)="onUrlInput($event)" autocomplete="off" />
                <i class="pi pi-link" [ngClass]="{'text-muted': isProcessingLink}"></i>
            </span>

            <!-- File Type Info -->
            <div class="file-info-section mt-4">
                <div class="supported-formats">
                    <small class="format-label">Supported format:</small>
                    <div class="format-badges">
                        <span class="format-badge">PDF</span>
                    </div>
                </div>
                <div class="size-limit">
                    <small class="size-label">Maximum file size: <strong>10 MB</strong></small>
                </div>
            </div>

              <!-- Instructions for OneDrive -->
            <div class="instructions-section">
                  <small class="format-label">Example URL: </small>

                <div class="instruction-item" style="margin-top: 1rem;">
                    <i class="pi pi-check-circle instruction-icon"></i>
                    <span>https://example.com/document.pdf</span>
                </div>
            </div>

            <div *ngIf="linkError" class="error-message">
                <i class="pi pi-exclamation-triangle"></i>
                {{ linkError }}
            </div>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <div class="dialog-footer">
            <p-button label="Cancel" icon="pi pi-times" (onClick)="closeLinkDialog()" [disabled]="isProcessingLink"
                styleClass="custom-purple-btn">
            </p-button>

            <p-button label="Upload from Link" icon="pi pi-download" [loading]="isProcessingLink"
                (onClick)="uploadFromLink()"
                [disabled]="!fileUrl.trim() || isProcessingLink"
                styleClass="custom-purple-btn">
            </p-button>
        </div>
    </ng-template>
</p-dialog>

<!-- Add loading overlay if needed -->
<div *ngIf="isProcessingLink" class="processing-overlay">
    <div class="processing-content">
        <i class="pi pi-spin pi-spinner processing-spinner"></i>
        <p>Downloading file from URL...</p>
    </div>
</div>